import { FileText, FileArchive, Megaphone, UserPlus, Search, FileUp } from "lucide-react";

export default function RolMenu({ user, currentModule, onSelectModule }) {
  // 🔹 Configuración base por rol
  const roleConfig = {
    administrador: [
      { label: "Nuevo Usuario", module: "NuevoUsuario", icon: UserPlus },
      { label: "Trámites", module: "Tramites", icon: FileText },
      { label: "Documentos", module: "DocumentosCorporativos", icon: FileArchive },
      { label: "Publicaciones", module: "Publicaciones", icon: Megaphone },
      { label: "Empleados", module: "BuscarEmpleado", icon: Search },
      { label: "Gestion Desprendibles", module: "GestionDesprendibles", icon: FileUp },
    ],
    "jefe de sección": [
      { label: "Trámites", module: "Tramites", icon: FileText },
      { label: "Documentos", module: "DocumentosCorporativos", icon: FileArchive },
    ],
    empleado: [
      { label: "Trámites", module: "Tramites", icon: FileText },
      { label: "Documentos", module: "DocumentosCorporativos", icon: FileArchive },
      // Aquí se agregan los módulos de Empleado en el futuro
      // tiketes a sistemas
    ],
  };

  // 🔹 Opciones adicionales por departamento
  const deptExtras = {
    prensa: [
      { label: "Publicaciones", module: "Publicaciones", icon: Megaphone }
      // Aquí se agregan los módulos de Prensa en el futuro
    ],
    "recursos humanos": [
        { label: "Usuario", module: "NuevoUsuario", icon: UserPlus },
        { label: "Empleados", module: "BuscarEmpleado", icon: Search },
        { label: "Gestion Desprendibles", module: "GestionDesprendibles", icon: FileUp },
        { label: "Trámites", module: "Tramites", icon: FileText },
      // Aquí se agregan los módulos de Recursos Humanos en el futuro
    ],
    sitemas: [
      // Aquí se agregan los módulos de Sistemas en el futuro
      // gestion de tiquetes
    ],
    contabilidad : [
      // Aquí se agregan los módulos de Contabilidad en el futuro
    ],
  };

  // 🔹 Construcción del menú según rol y departamento
  let menuItems = roleConfig[user.rol.toLowerCase()] || [];
  if (user.departamento) {
    menuItems = [...menuItems, ...(deptExtras[user.departamento.toLowerCase()] || [])];
  }

  // 🔹 Manejo del click
  const handleClick = (module) => {
    if (currentModule === module) {
      onSelectModule("Noticias");
    } else {
      onSelectModule(module);
    }
  };

  return (
    <div className="flex flex-col gap-3">
      {menuItems.map((item, idx) => {
        const Icon = item.icon;
        const isActive = currentModule === item.module;

        return (
          <button
            key={idx}
            onClick={() => handleClick(item.module)}
            className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-lg transition font-medium
              ${isActive
                ? "bg-lime text-black"
                : "bg-primary text-white hover:bg-secondary"}
            `}
          >
            <Icon className="w-7 h-7 sm:w-5 sm:h-5 transition-all duration-200" />
            <span className="hidden sm:inline">{item.label}</span>
          </button>
        );
      })}
    </div>
  );
}
